/**
 * Filter Dropdowns JavaScript
 * Handles Webflow-style dropdown functionality for collection filters
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Filter dropdowns initializing...');
  
  // Initialize dropdown functionality
  initializeDropdowns();
  
  function initializeDropdowns() {
    // Find all dropdown wrappers
    const dropdowns = document.querySelectorAll('.w-dropdown');
    
    dropdowns.forEach(dropdown => {
      const toggle = dropdown.querySelector('.w-dropdown-toggle');
      const list = dropdown.querySelector('.w-dropdown-list');
      
      if (!toggle || !list) return;
      
      // Remove existing listeners to prevent duplicates
      toggle.removeEventListener('click', handleToggleClick);
      
      // Add click listener to toggle
      toggle.addEventListener('click', handleToggleClick);
      
      // Ensure dropdown starts closed
      closeDropdown(dropdown);
    });
    
    // Add document click listener to close dropdowns when clicking outside
    document.removeEventListener('click', handleDocumentClick);
    document.addEventListener('click', handleDocumentClick);
  }
  
  function handleToggleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const dropdown = this.closest('.w-dropdown');
    const isOpen = dropdown.classList.contains('w--open');
    
    // Close all other dropdowns first
    closeAllDropdowns();
    
    // Toggle current dropdown
    if (!isOpen) {
      openDropdown(dropdown);
    }
  }
  
  function handleDocumentClick(e) {
    // If click is not inside any dropdown, close all dropdowns
    if (!e.target.closest('.w-dropdown')) {
      closeAllDropdowns();
    }
  }
  
  function openDropdown(dropdown) {
    const toggle = dropdown.querySelector('.w-dropdown-toggle');
    const list = dropdown.querySelector('.w-dropdown-list');
    
    dropdown.classList.add('w--open');
    if (toggle) toggle.classList.add('w--open');
    if (list) {
      list.classList.add('w--open');
      list.style.display = 'block';
    }
    
    console.log('Dropdown opened:', dropdown);
  }
  
  function closeDropdown(dropdown) {
    const toggle = dropdown.querySelector('.w-dropdown-toggle');
    const list = dropdown.querySelector('.w-dropdown-list');
    
    dropdown.classList.remove('w--open');
    if (toggle) toggle.classList.remove('w--open');
    if (list) {
      list.classList.remove('w--open');
      list.style.display = 'none';
    }
  }
  
  function closeAllDropdowns() {
    document.querySelectorAll('.w-dropdown').forEach(closeDropdown);
  }
  
  // Re-initialize dropdowns when content is dynamically updated
  window.reinitializeDropdowns = initializeDropdowns;
  
  // Integration with collection filter system
  function handleFilterClick(e) {
    // Let the collection filter system handle the filtering logic
    // This just ensures dropdowns stay open for multiple selections
    e.stopPropagation();
  }
  
  // Add click handlers to filter links to prevent dropdown from closing
  function attachFilterLinkHandlers() {
    document.querySelectorAll('.filter-link').forEach(link => {
      link.addEventListener('click', handleFilterClick);
    });
  }
  
  // Override the document click handler to be more selective
  function handleDocumentClick(e) {
    // Don't close if clicking on filter options
    if (e.target.closest('.filter-link') || e.target.closest('.filter_form_checkbox-icon')) {
      return;
    }
    
    // If click is not inside any dropdown, close all dropdowns
    if (!e.target.closest('.w-dropdown')) {
      closeAllDropdowns();
    }
  }
  
  // Update the initialization to include filter link handlers
  const originalInitialize = initializeDropdowns;
  initializeDropdowns = function() {
    originalInitialize();
    setTimeout(() => {
      attachFilterLinkHandlers();
    }, 100);
  };
  
  console.log('Filter dropdowns initialized successfully with collection filter integration');
});
